export default class SmoothScroll {
  constructor(el) {
    this.el = el;

    const triggers = el.querySelectorAll('[data-trigger]');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.handleClicks);
    });
  }

  handleClicks(event) {
    const trigger = event.target;
    const headerEl = document.querySelector('[data-header]');
    const contentEl = document.getElementById(trigger.dataset.trigger);

    event.preventDefault();

    window.scrollTo({
      left: 0,
      top: contentEl.offsetTop - headerEl.getBoundingClientRect().height,
      behavior: 'smooth',
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/SmoothScroll.js